export default __webpack_public_path__ + "static/cards-6cee656e39f554327da6bca3efea7458.png";